export default __webpack_public_path__ + "assets/ig_icon.png";